import { createRouter, createWebHistory } from "vue-router";
import formView from "@/views/FormView.vue";
import Maintenance from "@/views/Maintenance.vue";
import ErrorPage from "@/views/ErrorPage.vue";
import { useGlobalStore } from "@/stores";

const routes = [
    {
        path: "/",
        name: "form",
        component: formView,
    },
    {
        path: "/maintenance",
        name: "maintenance",
        component: Maintenance,
    },
    {
        path: "/:pathMatch(.*)*",
        component: ErrorPage,
        props: { errorCode: 404 },
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
});

router.beforeEach((to) => {
    const global = useGlobalStore();
    if (global.systemMaintenance && to.name !== "maintenance") {
        return { name: "maintenance" };
    }
    return true;
});

export { routes };

export default router;
